import { FAQ_ITEMS } from "../content";
import "./Faq.css";

/** Preguntas frecuentes (#preguntas): el título queda fijo a la izquierda en
 * escritorio mientras bajan las 7 preguntas; cada una es un <details> nativo
 * (teclado y lectores de pantalla sin código extra) con un «+» que gira. */
export function Faq() {
  return (
    <section id="preguntas" className="t123-section t123-section--soft t123-faq" aria-labelledby="t123-faq-title">
      <div className="t123-shell t123-faq__grid">
        <div className="t123-faq__intro">
          <h2 id="t123-faq-title" className="t123-h2">
            Preguntas frecuentes
          </h2>
          <p className="t123-lead">¿Tienes otra duda? Te la resolvemos en tu demo.</p>
          <a className="t123-link-arrow t123-faq__cta" href="#demo">
            Pedir demo
          </a>
        </div>

        <div className="t123-faq__list">
          {FAQ_ITEMS.map((item) => (
            <details key={item.q} className="t123-faq__item">
              <summary>
                <span className="t123-faq__question">{item.q}</span>
                <span className="t123-faq__icon" aria-hidden="true" />
              </summary>
              <div className="t123-faq__answer">
                <p>{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
